export function getMonthYearOptions() {
  const options: Array<{ value: string; label: string }> = [];
  const now = new Date();

  for (let i = 0; i < 12; i += 1) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const value = `${month}-${year}`;
    const monthName = date.toLocaleString("default", { month: "long" });
    options.push({
      value,
      label: `${monthName} ${year}`,
    });
  }

  return options;
}

export function resolveReadingCount(data: unknown): number {
  if (!data) return 0;

  const payload =
    typeof data === "object" && data !== null && "data" in data
      ? (data as { data?: unknown }).data
      : data;

  if (typeof payload === "number") return payload;
  if (typeof payload === "object" && payload !== null) {
    const record = payload as Record<string, unknown>;
    return Number(
      record.totalReadingCount ?? record.totalReadingsInMonth ?? record.count ?? 0,
    );
  }

  return 0;
}
